"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E_LocaleServer = exports.LOCALES = void 0;
exports.LOCALES = [
    'cn', 'en', 'tw', 'jp'
];
// ref: https://confluence.zhihuiya.com/display/~zhanggang/User+Service+Design+And+APIs
var E_LocaleServer;
(function (E_LocaleServer) {
    E_LocaleServer["zh_CN"] = "zh_CN";
    E_LocaleServer["en_US"] = "en_US";
    E_LocaleServer["zh_TW"] = "zh_TW";
    E_LocaleServer["ja_JP"] = "ja_JP";
})(E_LocaleServer = exports.E_LocaleServer || (exports.E_LocaleServer = {}));
//# sourceMappingURL=types.js.map